/**
 * Aciona a impressão da página aplicando temporariamente uma classe no <body>,
 * permitindo que o CSS (`@media print`) ajuste o layout apenas durante a impressão.
 *
 * A classe é removida em `afterprint` (com fallback por timeout, pois alguns
 * navegadores não disparam o evento de forma confiável).
 *
 * @param bodyClass classe adicionada ao body durante a impressão
 * @param beforePrint callback opcional executado antes do window.print()
 *   (ex.: forçar renderização de conteúdo lazy). Pode retornar uma Promise;
 *   a impressão só é disparada após sua resolução.
 */
export async function printWithBodyClass(
  bodyClass: string,
  beforePrint?: () => void | Promise<void>,
): Promise<void> {
  if (beforePrint) {
    await beforePrint();
  }

  document.body.classList.add(bodyClass);

  const cleanup = () => {
    document.body.classList.remove(bodyClass);
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);
  // Fallback: alguns navegadores não disparam afterprint de forma confiável.
  setTimeout(cleanup, 60000);

  window.print();
}
